import withAutoComplete from 'src/wiredComponent/HOC/withAutoComplete';
import AutoComplete from '../../../components/form/AutoComplete';

const WiredAutoComplete = withAutoComplete(AutoComplete)

export default WiredAutoComplete;
